/* eslint-disable jsx-a11y/anchor-has-content */

import React from 'react';
import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';
import { IconGeneric, Button } from '@spotahome/ui-library';

import './Paginator.scss';

const Paginator = ({
  previousButtonDisabled,
  nextButtonDisabled,
  previousPageUrl,
  nextPageUrl,
  onPreviousButtonClick,
  onNextButtonClick
}) => (
  <div className="paginator">
    <Button
      fullWidth
      color="tertiary"
      size="large"
      onClick={onPreviousButtonClick}
      dataTest="paginator-btn-prev"
      disabled={previousButtonDisabled}
      renderContent={() => (
        <>
          <IconGeneric name="angle-left" /> {trans('paginator.label.prev')}
          <a href={previousPageUrl} />
        </>
      )}
    />
    <Button
      color="tertiary"
      size="large"
      fullWidth
      onClick={onNextButtonClick}
      dataTest="paginator-btn-next"
      disabled={nextButtonDisabled}
      renderContent={() => (
        <>
          {trans('paginator.label.next')} <IconGeneric name="angle-right" />
          <a href={nextPageUrl} />
        </>
      )}
    />
  </div>
);

Paginator.propTypes = {
  previousButtonDisabled: PropTypes.bool,
  nextButtonDisabled: PropTypes.bool,
  onPreviousButtonClick: PropTypes.func,
  onNextButtonClick: PropTypes.func,
  previousPageUrl: PropTypes.string.isRequired,
  nextPageUrl: PropTypes.string.isRequired
};

Paginator.defaultProps = {
  previousButtonDisabled: false,
  nextButtonDisabled: false,
  onPreviousButtonClick: () => {},
  onNextButtonClick: () => {}
};

export default Paginator;
